export default __webpack_public_path__ + "static/media/pantry2-after2-1024w.557fcb94.avif";